/*=========================================================================================
  File Name: routes.js
  Description: List of Routes for vue-router. Lazy loading is enabled.
==========================================================================================*/

import { ACCESS_META_BY_ROUTE_NAME } from '@/constants/accessTargets'

const routes = [
  {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
    path: '',
    component: () => import('@/layouts/main/Main.vue'),
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import('@/views/Home.vue'),
        meta: {
          pageTitle: 'Dashboards',
        },
      },
      {
        path: '/charts',
        name: 'charts',
        component: () => import('@/views/Charts.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Charts',
              active: true,
            },
          ],
          pageTitle: 'Charts',
        },
      },
      {
        path: '/content',
        name: 'content',
        component: () => import('@/views/ContentList.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Content',
              active: true,
            },
          ],
          pageTitle: 'Content',
        },
      },
      {
        path: '/create/course',
        name: 'create-course',
        component: () => import('@/views/CourseForm.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Create',
            },
            {
              title: 'Course',
              active: true,
            },
          ],
          pageTitle: 'Create Course',
        },
      },
      {
        path: '/create/video',
        name: 'create-video',
        component: () => import('@/views/VideoForm.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Create',
            },
            {
              title: 'Video',
              active: true,
            },
          ],
          pageTitle: 'Create Video',
        },
      },
      {
        path: '/create/learning-path',
        name: 'create-lp',
        component: () => import('@/views/LPForm.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Create',
            },
            {
              title: 'Learning Path',
              active: true,
            },
          ],
          pageTitle: 'Create Learning Path',
        },
      },
      {
        path: '/create/quiz',
        name: 'create-quiz',
        component: () => import('@/views/QuizForm.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Create',
            },
            {
              title: 'Quiz',
              active: true,
            },
          ],
          pageTitle: 'Create Quiz',
        },
      },
      {
        path: '/create/lab',
        name: 'create-lab',
        component: () => import('@/views/LabForm.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Create',
            },
            {
              title: 'Lab',
              active: true,
            },
          ],
          pageTitle: 'Create Lab',
        },
      },
      {
        path: '/create/exercise',
        name: 'create-exercise',
        component: () => import('@/views/ExerciseForm.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Create',
            },
            {
              title: 'Exercise',
              active: true,
            },
          ],
          pageTitle: 'Create Exercise',
        },
      },
      {
        path: '/create/iframe',
        name: 'create-iframe',
        component: () => import('@/views/IFrameForm.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Create',
            },
            {
              title: 'iFrame',
              active: true,
            },
          ],
          pageTitle: 'Create iFrame',
        },
      },
      {
        path: '/create/collection',
        name: 'create-collection',
        component: () => import('@/views/CollectionForm.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Create',
            },
            {
              title: 'Collection',
              active: true,
            },
          ],
          pageTitle: 'Create Collection',
        },
      },
      {
        path: '/create/sonar',
        name: 'create-sonar',
        component: () => import('@/views/SonarForm.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Create',
            },
            {
              title: 'Sonar',
              active: true,
            },
          ],
          pageTitle: 'Create Skill Sonar',
        },
      },
      {
        path: '/edit/collection/:id',
        name: 'edit-collection',
        component: () => import('@/views/CollectionForm.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Edit',
            },
            {
              title: 'Collection',
              active: true,
            },
          ],
          pageTitle: 'Edit Collection',
        },
      },
      {
        path: '/bulk/Collection-upload',
        name: 'bulk-collection-upload',
        component: () => import('@/views/BulkCollectionForm.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Create',
            },
            {
              title: 'Collection',
              url: '/create/Collection',
            },
            {
              title: 'Bulk',
              active: true,
            },
          ],
          pageTitle: 'Bulk Collection Upload',
        },
      },
      {
        path: '/edit/course/:id',
        name: 'edit-course',
        component: () => import('@/views/CourseForm.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Edit',
            },
            {
              title: 'Course',
              active: true,
            },
          ],
          pageTitle: 'Edit Course',
        },
      },
      {
        path: '/edit/video/:id',
        name: 'edit-video',
        component: () => import('@/views/VideoForm.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Edit',
            },
            {
              title: 'Video',
              active: true,
            },
          ],
          pageTitle: 'Edit Video',
        },
      },
      {
        path: '/edit/learning-path/:id',
        name: 'edit-lp',
        component: () => import('@/views/LPForm.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Edit',
            },
            {
              title: 'Learning Path',
              active: true,
            },
          ],
          pageTitle: 'Edit Learning Path',
        },
      },
      {
        path: '/edit/quiz/:id',
        name: 'edit-quiz',
        component: () => import('@/views/QuizForm.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Edit',
            },
            {
              title: 'Quiz',
              active: true,
            },
          ],
          pageTitle: 'Edit Quiz',
        },
      },
      {
        path: '/bulk/quiz-upload',
        name: 'bulk-quiz-upload',
        component: () => import('@/views/BulkQuizForm.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Create',
            },
            {
              title: 'Quiz',
              url: '/create/quiz',
            },
            {
              title: 'Bulk',
              active: true,
            },
          ],
          pageTitle: 'Bulk Quiz Upload',
        },
      },
      {
        path: '/edit/lab/:id',
        name: 'edit-lab',
        component: () => import('@/views/LabForm.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Edit',
            },
            {
              title: 'Lab',
              active: true,
            },
          ],
          pageTitle: 'Edit Lab',
        },
      },
      {
        path: '/edit/exercise/:id',
        name: 'edit-exercise',
        component: () => import('@/views/ExerciseForm.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Edit',
            },
            {
              title: 'Exercise',
              active: true,
            },
          ],
          pageTitle: 'Edit Exercise',
        },
      },
      {
        path: '/edit/iframe/:id',
        name: 'edit-iframe',
        component: () => import('@/views/IFrameForm.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Edit',
            },
            {
              title: 'iFrame',
              active: true,
            },
          ],
          pageTitle: 'Edit iFrame',
        },
      },
      {
        path: '/edit/sonar/:id',
        name: 'edit-sonar',
        component: () => import('@/views/SonarForm.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Edit',
            },
            {
              title: 'Skill Sonar',
              active: true,
            },
          ],
          pageTitle: 'Edit Skill Sonar',
        },
      },
      {
        path: '/reviews',
        name: 'reviews',
        component: () => import('@/views/Reviews.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Reviews',
              active: true,
            },
          ],
          pageTitle: 'Reviews',
        },
      },
      {
        path: '/reports',
        name: 'reports',
        component: () => import('@/views/Reports.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Reports',
              active: true,
            },
          ],
          pageTitle: 'Reports',
        },
      },
      {
        path: '/certifications',
        name: 'certifications',
        component: () => import('@/views/Certifications.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Certifications',
              active: true,
            },
          ],
          pageTitle: 'Certifications',
          headerAction: {
            label: 'Create New Certification',
            route: { name: 'create-certification' },
          },
        },
      },
      {
        path: '/certifications/:id/:name',
        name: 'certification-versions',
        beforeEnter: (to, from, next) => {
          const title = to.params.name || 'Certification Version History'
          to.meta.breadcrumb[2].title = title
          to.meta.pageTitle = title
          next()
        },
        component: () => import('@/views/CertificationVersionHistory.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Certifications',
              url: '/certifications',
            },
            {
              title: 'Certification Version History',
              active: true,
            },
          ],
          pageTitle: 'Certification Version History',
        },
      },
      {
        path: '/create/certification',
        name: 'create-certification',
        component: () => import('@/views/CertificationEditPage.vue'),
        meta: {
          isCreation: true,
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Certifications',
              url: '/certifications',
            },
            {
              title: 'Create New Certification',
              active: true,
            },
          ],
          pageTitle: 'Create New Certification',
        },
      },
      {
        path: '/certification/:certificationId/version/:certificationVersionId/edit',
        name: 'certification-version-edit',
        beforeEnter: (to, from, next) => {
          const historyTitle = 'Certification Version History'
          to.meta.breadcrumb[2].url =
            '/certifications/' +
            to.params.certificationId +
            '/' +
            encodeURIComponent(historyTitle)
          next()
        },
        component: () => import('@/views/CertificationEditPage.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: '/',
            },
            {
              title: 'Certifications',
              url: '/certifications',
            },
            {
              title: 'Certification Version',
            },
            {
              title: 'Exam',
            },
            {
              title: 'Edit',
              active: true,
            },
          ],
          pageTitle: 'Edit',
        },
      },
    ],
  },
  // =============================================================================
  // FULL PAGE LAYOUTS
  // =============================================================================
  {
    path: '',
    component: () => import('@/layouts/full-page/FullPage.vue'),
    children: [
      // =============================================================================
      // PAGES
      // =============================================================================
      {
        path: '/login',
        name: 'login',
        beforeEnter: (to, from, next) => {
          const { VUE_APP_MY_INE_URL: ssoUrl } = process.env
          if (!ssoUrl) {
            next()
          } else {
            const redirectUrl = window.location.href.includes('logout')
              ? window.location.origin
              : window.location.href
            window.location.href = `${ssoUrl}/login?redirect_url=${redirectUrl}`
          }
        },
        component: () => import('@/views/pages/Login.vue'),
      },
      {
        path: '/forgot-password',
        name: 'page-forgot-password',
        component: () => import('@/views/pages/ForgotPassword.vue'),
      },
      {
        path: '/error-404',
        name: 'page-error-404',
        component: () => import('@/views/pages/Error404.vue'),
      },
      {
        path: '/not-authorized',
        name: 'page-not-authorized',
        component: () => import('@/views/pages/NotAuthorized.vue'),
      },
      {
        path: '/maintenance',
        name: 'page-maintenance',
        component: () => import('@/views/pages/Maintenance.vue'),
      },
    ],
  },
  // Redirect to 404 page, if no match found
  {
    path: '*',
    redirect: '/error-404',
  },
]

routes[0].children = routes[0].children.map(route => {
  if (!route.name || !ACCESS_META_BY_ROUTE_NAME[route.name]) {
    return route
  }

  return {
    ...route,
    meta: {
      ...(route.meta || {}),
      ...ACCESS_META_BY_ROUTE_NAME[route.name],
    },
  }
})

export default routes
